import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePage, loadIntegrationList } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/integrations/")({
  loader: async () => {
    const [page, integrationData] = await Promise.all([
      loadStandalonePage({ data: { path: "integrations/_index.md" } }),
      loadIntegrationList(),
    ]);
    const blocks =
      (page.blocks as Array<{ block: string; [key: string]: unknown }>) || [];

    // Inject dynamic integration data into the catalog block
    const enrichedBlocks = blocks.map((block) => {
      if (block.block !== "integrations-category-grid") return block;
      return {
        ...block,
        _dynamicCategories: integrationData.byCategory,
      };
    });

    return {
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      blocks: enrichedBlocks,
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: loaderData?.seo_title || "C1 Connectors | C1",
      description:
        loaderData?.seo_description ||
        "Connect C1 to your entire tech stack.",
      url: "/integrations",
    }),
    links: seoLinks({ url: "/integrations" }),
  }),
  component: IntegrationsIndex,
});

function IntegrationsIndex() {
  const { blocks } = Route.useLoaderData();
  return <BlockRenderer blocks={blocks} />;
}
